// Copyright (c) 2016 Deere & Company

import SurveyQuestionsContainer from './survey-questions-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    isEditable: state.claims.mccFollowup.isEditable,
    questions: state.claims.mccFollowup.claim.questions,
    questionsRequiredOptions: state.claims.mccFollowup.questionsRequiredOptions
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SurveyQuestionsContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/survey-questions/index.js